// appInstanceModel.js

function normalizeString(value) {
  return String(value || '').trim();
}

export function normalizeAppInstanceDatabaseEntry(entry = {}) {
  const typeKey = normalizeString(entry?.typeKey);
  const databaseKey = normalizeString(entry?.collectionKey || entry?.databaseKey);
  if (!typeKey || !databaseKey) return null;

  return {
    typeKey,
    databaseKey,
    collectionKey: databaseKey,
    studioDatabaseKey: normalizeString(entry?.studioDatabaseKey) || null,
    label: normalizeString(entry?.label) || '',
    labelPlural: normalizeString(entry?.labelPlural) || '',
  };
}

export function normalizeAppInstanceRecord(data = {}, docId = '') {
  const key = normalizeString(data?.key || docId);
  if (!key) return null;

  const databases = (Array.isArray(data?.databases) ? data.databases : [])
    .map((entry) => normalizeAppInstanceDatabaseEntry(entry))
    .filter(Boolean);

  return {
    addonKey: normalizeString(data?.addonKey) || null,
    databases,
    dateCreated: data?.dateCreated || null,
    dateModified: data?.dateModified || null,
    installedBy: normalizeString(data?.installedBy) || null,
    key,
    source: normalizeString(data?.source) || null,
    status: normalizeString(data?.status) || 'active',
    storeAddonTitle: normalizeString(data?.storeAddonTitle) || null,
    storeAppKey: normalizeString(data?.storeAppKey) || null,
    storeAppTitle: normalizeString(data?.storeAppTitle) || null,
    storeTermLabel: normalizeString(data?.storeTermLabel) || null,
    storeVersionKey: normalizeString(data?.storeVersionKey) || null,
    studioAppKey: normalizeString(data?.studioAppKey) || null,
    studioAppTitle: normalizeString(data?.studioAppTitle) || null,
    termKey: normalizeString(data?.termKey) || null,
    title: normalizeString(data?.title) || '',
    baseKey: normalizeString(data?.baseKey) || '',
  };
}

export function getAppInstanceGroupKey(instanceKey) {
  const cleanedInstanceKey = normalizeString(instanceKey);
  return cleanedInstanceKey ? `instance:${cleanedInstanceKey}` : '';
}

export function getAppInstanceDisplayTitle(instance) {
  return normalizeString(instance?.title)
    || normalizeString(instance?.studioAppTitle)
    || normalizeString(instance?.storeAppTitle)
    || normalizeString(instance?.storeAddonTitle)
    || normalizeString(instance?.storeTermLabel)
    || 'Installed App';
}
